import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LazyViewModule } from '../lazy-view/lazy-view.module';
import { AlertMessageModule } from '../shared/alert-message/alert-message.module';
import { PreloadModule } from '../shared/directives/preload/preload.module';
import { SharedComponentsModule } from '../shared/directives/shared-components.module';
import { FocusOnLoadModule } from '../shared/focus-on-load/focus-on-load.module';
import { IconFontModule } from '../shared/icon-font/icon-font.module';
import { AppTileComponent } from './app-tile.component';
import { AppTilesListComponent } from './app-tiles-list.component';
import { AppTilesSectionComponent } from './app-tiles-section.component';
import { CreateMenuPlaceHolderTileComponent } from './create-menu-placeholder-tile.component';

@NgModule({
    imports: [
        AlertMessageModule,
        CommonModule,
        FocusOnLoadModule,
        IconFontModule,
        LazyViewModule,
        PreloadModule,
        ScrollingModule,
        SharedComponentsModule
    ],
    declarations: [
        AppTileComponent,
        AppTilesListComponent,
        AppTilesSectionComponent,
        CreateMenuPlaceHolderTileComponent
    ],
    exports: [
        AppTilesListComponent,
        AppTilesSectionComponent
    ]
})
export class AppTilesModule { }
